import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { sysLogin } from "@/api/api-basic";
import sha256 from "js-sha256";
import { State, Mutation } from "vuex-class";
import { getMerchantInfo } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import { piUtSaveStorage } from "@/utils/utils";
import { piAhOut } from "@/utils/ajaxdata.helper";
let PiLogin = class PiLogin extends Vue {
    constructor() {
        super(...arguments);
        this.test = "light";
        this.loading = false;
        this.logoPageInfo = {
            // loginPageSlogan: "为 美 好 生 活 充 电",
            fullName: "",
        };
        this.changeLangList = [
            {
                value: "zh-CN",
                label: "简体中文",
            },
            {
                value: "en-US",
                label: "English",
            },
        ];
        this.formInline = {
            userName: "",
            password: "",
            loginType: "0",
            subSystemPkId: "3",
            verCode: "",
            changeLang: "zh",
        };
        this.ruleInline = {
            userName: [
                {
                    required: true,
                    message: i18n.t("login.userNamePl"),
                    trigger: "blur",
                },
            ],
            password: [
                {
                    required: true,
                    message: i18n.t("login.passwordPl"),
                    trigger: "blur",
                },
                {
                    type: "string",
                    min: 6,
                    message: i18n.t("login.passwordMax"),
                    trigger: "blur",
                },
            ],
        };
    }
    changeLangFn(val) {
        this.$i18n.locale = val;
        localStorage.setItem("language", val);
        location.reload();
    }
    handleSubmit() {
        const eleSub = this.$refs["formInline"] || {};
        eleSub.validate((valid) => {
            if (valid) {
                this.submitData();
            }
        });
    }
    submitData2() {
        piUtSaveStorage("loginData", this.formInline);
        this.$router.push("/");
    }
    async submitData() {
        const json = JSON.parse(JSON.stringify(this.formInline));
        json.password = sha256.sha256(json.password);
        this.loading = true;
        const ret = await sysLogin(json);
        if (ret.status == this["$config"].apiStatus) {
            piUtSaveStorage("loginData", ret.data[0]);
            this.$router.push("/").catch(() => {
                console.log("login-error");
            });
            if (ret.data[0].expireRemindDate != null &&
                ret.data[0].expireRemindDate >= 0) {
                this["$Notice"].warning({
                    title: i18n.t("tips") + "",
                    desc: i18n.t("login.accountTime") +
                        ret.data[0].expireRemindDate +
                        i18n.t("login.accountTime2"),
                    duration: 15,
                });
            }
        }
        this.loading = false;
    }
    async getMerchantInfo(merchantPkId) {
        const ret = await getMerchantInfo({
            merchantPkId: merchantPkId,
        });
        if (ret.status == this["$config"].apiStatus) {
            const data = ret.data[0];
            this.logoPageInfo.title = data.fullName;
        }
    }
    mounted() {
        // const _self = this;
        this.formInline.changeLang = this.$i18n.locale;
        if (this.sys.isLogin) {
            this.SET_ISLOGIN(false);
            piAhOut();
        }
        document.onkeydown = (event) => {
            if (event.keyCode === 13 && !this.loading) {
                this.handleSubmit();
                return false;
            }
        };
        // if (this.$route.query.merchantPkId) {
        //   const query: objAny = this.$route.query;
        //   // this.getMerchantInfo(query.merchantPkId);
        // }
    }
    destroyed() {
        document.onkeydown = null;
    }
};
__decorate([
    State("sys")
], PiLogin.prototype, "sys", void 0);
__decorate([
    Mutation("SET_ISLOGIN")
], PiLogin.prototype, "SET_ISLOGIN", void 0);
PiLogin = __decorate([
    Component
], PiLogin);
export default PiLogin;
